// "Deleted" popup with an Undo button that counts down and closes by itself when time runs out.
// Resolves true if the user clicked Undo in time.
export function askToUndo (swal, { title, html, seconds = 10 }) {
  let left = seconds
  let interval = null
  const label = () => `<i class="fa fa-undo"></i> Undo (${left}s)`
  return swal({
    title,
    html: `${html}<div class="nv-undo-timer"><span style="animation-duration: ${seconds}s"></span></div>`,
    type: 'success',
    showCancelButton: true,
    confirmButtonText: label(),
    cancelButtonText: 'Close',
    timer: seconds * 1000,
    customClass: 'nv-undo-popup',
    onOpen: () => {
      interval = setInterval(() => {
        left = Math.max(0, left - 1)
        const button = swal.getConfirmButton && swal.getConfirmButton()
        if (button) button.innerHTML = label()
      }, 1000)
    },
    onClose: () => clearInterval(interval)
  }).then(result => !!(result && result.value))
}



// WEBPACK FOOTER //
// ./src/components/shared/undoCountdown.js